import Vue from 'vue';

// Vue.component('card', require('./components/Basic/Card').default);
// Vue.component('resource-index', require('./components/Resource/ResourceIndex'));
Vue.component('modal', require('./components/Basic/Modal').default);